import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import zhTW from './locales/zh-TW.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'zh-TW': { translation: zhTW },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'zh-TW'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      convertDetectedLanguage: (language: string) => /^zh(?:-|$)/i.test(language) ? 'zh-TW' : language,
    },
    interpolation: { escapeValue: false },
  });

function updateDocumentLanguage() {
  document.documentElement.lang = i18n.resolvedLanguage ?? i18n.language;
  document.title = i18n.t('app.title');
}

i18n.on('languageChanged', updateDocumentLanguage);
if (i18n.isInitialized) updateDocumentLanguage();
else i18n.on('initialized', updateDocumentLanguage);

